import { RootState, useSelector } from '../redux/store';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ProductType } from '../@types/model/productType';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getProductTypes, productTypeState } from 'recoil/productTypeState';

interface ProductTypePickerProps {
  productTypePreset: string;
  changeHandler: (productTypePreset: string) => void;
  productTypeAvailable: string[];
  error: any;
  touched: any;
}

const ProductTypePicker = (props: ProductTypePickerProps) => {
  const { t } = useTranslation();
  const { loaded } = useSelector((state: RootState) => state.user);
  const [productTypesFiltered, setProductTypesFiltered] = useState<ProductType[]>([]);
  const productTypes: ProductType[] = useRecoilValue(productTypeState);
  const setProductTypes = useSetRecoilState(productTypeState);

  useEffect(() => {
    if (productTypes.length === 0)
      getProductTypes().then((productTypes: ProductType[]) => setProductTypes(productTypes));
  }, []);

  useEffect(() => {
    if (props.productTypeAvailable.length > 0) {
      let filteredProductsTypes = productTypes.filter((productType: ProductType) => {
        if (props.productTypeAvailable.includes(productType.guid)) return true;
        return false;
      });
      setProductTypesFiltered(filteredProductsTypes);
    } else {
      setProductTypesFiltered(productTypes);
    }
  }, [productTypes, props.productTypeAvailable]);

  if (!loaded) {
    return null;
  }
  return (
    <FormControl fullWidth>
      <InputLabel id={'product-type-select-label'}>{t('select_product_type')}</InputLabel>
      <Select
        labelId={'product-type-select-label'}
        id={'product-type-select'}
        value={props.productTypePreset}
        label={t('select_product_type').toString()}
        onChange={(event) => {
          props.changeHandler(event.target.value as string);
        }}
        error={Boolean(props.touched && props.error)}
      >
        {productTypesFiltered.map((dt) => {
          return (
            <MenuItem key={dt.guid} value={dt.guid}>
              {dt.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default ProductTypePicker;
